import dateFormat from "dateformat";
import * as apis from "../../apis";
import { Shop } from "../../redux/slices/auth";

// purchaseOrder

export function getCalculateData(shop: Shop, startDate: any, endDate: any) {
  return new Promise(async (resolve, reject) => {
    try {
      const { COMPANY_ID, SHOP_ID } = shop;
      // console.log("startDate : ", `${dateFormat(startDate, "yyyy-mm-dd 00:00:00")}`)
      // console.log("endDate : ", `${dateFormat(endDate, "yyyy-mm-dd 00:00:00")}`)
      const res: any = await apis.item.getItemsSalesAndNangmanOrdersByPlant(
        String(COMPANY_ID),
        String(SHOP_ID),
        startDate,
        endDate
        // `${dateFormat(startDate, "yyyy-mm-dd 00:00:00")}`,
        // `${dateFormat(endDate, "yyyy-mm-dd 23:59:59")}`
      );
      if (res == null || res.data == null) {
        resolve([]);
        return;
      }
      let tempArr: any = [];
      const emptyArr: any = [];
      for (var ind in res.data) {
        var row = res.data[ind];
        if (!isNaN(Number.parseInt(row.REPRESENTATIVE_ID))) {
          row.REPRESENTATIVE_ID = Number.parseInt(row.REPRESENTATIVE_ID);
        }
        if (row.ITEM_REC_ORDER > 0) {
          tempArr.push(row);
        } else {
          emptyArr.push(row);
        }
      }
      tempArr = tempArr.concat(emptyArr);
      resolve(tempArr);
    } catch (e) {
      console.log("getCalculateData error : ", e);
      reject(e);
    }
  });
}

// export function getOrderAnalyticsData(
//   shop: Shop,
//   startDate: any,
//   endDate: any
// ) {
//   return new Promise(async (resolve, reject) => {
//     try {
//       const { COMPANY_ID, SHOP_ID } = shop;
//       const res: any =
//         await apis.purchaseOrder.getSalesAndOrdersAndNangmanAmountByPlant(
//           String(COMPANY_ID),
//           String(SHOP_ID),
//           startDate,
//           endDate
//           // `${dateFormat(startDate, "yyyy-mm-dd 00:00:00")}`,
//           // `${dateFormat(endDate, "yyyy-mm-dd 23:59:59")}`
//         );

//       if (res == null || res.data == null) {
//         resolve([]);
//         return;
//       }
//       resolve(res.data);
//     } catch (e) {
//       console.log("getOrderAnalyticsData error : ", e);
//       reject(e);
//     }
//   });
// }

export function getShopOrdersBySalesByDate(
  shop: Shop,
  startDate: any,
  endDate: any
) {
  return new Promise(async (resolve, reject) => {
    try {
      const { COMPANY_ID, SHOP_ID } = shop;
      const res: any = await apis.purchaseOrder.getShopOrdersBySalesByDate(
        String(COMPANY_ID),
        String(SHOP_ID),
        startDate,
        endDate
        // `${dateFormat(startDate, "yyyy-mm-dd 00:00:00")}`,
        // `${dateFormat(endDate, "yyyy-mm-dd 23:59:59")}`
      );

      if (res == null || res.data == null) {
        resolve([]);
        return;
      }
      resolve(res.data);
    } catch (e) {
      console.log("getShopOrdersBySalesByDate error : ", e);
      reject(e);
    }
  });
}

// item
// export function getInventoryData(shop: Shop) {
//   return new Promise(async (resolve, reject) => {
//     try {
//       const { COMPANY_ID, SHOP_ID } = shop;
//       const res: any = await apis.item.getLatestItemsRealInvAndSmartInvByPlant(
//         String(COMPANY_ID),
//         String(SHOP_ID)
//       );
//       if (res == null || res.data == null) {
//         resolve([]);
//         return;
//       }
//       resolve(res.data);
//     } catch (e) {
//       console.log("getInventoryData error : ", e);
//       reject(e);
//     }
//   });
// }

// sales

// notice(shop)
export function getNoticeList(
  COMPANY_ID: string,
  SHOP_ID: string,
  lastNoticeIndex: string,
  noticeAmount: string,
  sortType: string
) {
  return new Promise(async (resolve, reject) => {
    try {
      const res: any = await apis.notice.getNoticeList(
        COMPANY_ID,
        SHOP_ID,
        lastNoticeIndex,
        noticeAmount,
        sortType
      );
      if (res == null || res.data == null) {
        resolve([]);
        return;
      }

      resolve(res.data);
    } catch (e) {
      console.log("getNoticeList error : ", e);
      reject(e);
    }
  });
}

export function getFixedNoticeList(COMPANY_ID: string, SHOP_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const res: any = await apis.notice.getFixedNoticeList(
        COMPANY_ID,
        SHOP_ID
      );
      if (res == null || res.data == null) {
        resolve([]);
        return;
      }

      resolve(res.data);
    } catch (e) {
      console.log("getFixedNoticeList error : ", e);
      reject(e);
    }
  });
}

export function getNewNoticeList(COMPANY_ID: string, SHOP_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const res: any = await apis.notice.getNewNoticeList(COMPANY_ID, SHOP_ID);
      if (res == null || res.data == null) {
        resolve([]);
        return;
      }
      resolve(res.data);
    } catch (e) {
      console.log("getNewNoticeList error : ", e);
      reject(e);
    }
  });
}

export function getNotice(
  COMPANY_ID: string,
  SHOP_ID: string,
  POST_ID: string
) {
  return new Promise(async (resolve, reject) => {
    try {
      const res: any = await apis.notice.getNotice(
        COMPANY_ID,
        SHOP_ID,
        POST_ID
      );
      if (res == null || res.data == null) {
        resolve([]);
        return;
      }

      resolve(res.data);
    } catch (e) {
      console.log("getNotice error : ", e);
      reject(e);
    }
  });
}

export function getShopNoticeGroup(COMPANY_ID: string, SHOP_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const res: any = await apis.notice.getShopNoticeGroup(
        COMPANY_ID,
        SHOP_ID
      );
      if (res == null || res.data == null) {
        resolve([]);
        return;
      }

      console.log("getNoticeGroup", res);
      resolve(res.data);
    } catch (e) {
      console.log("getNoticeGroup error : ", e);
      reject(e);
    }
  });
}

export function getAttachment(
  COMPANY_ID: string,
  SHOP_ID: string,
  POST_ID: string,
  FILE_ID: string,
  INTERNAL_URL: string
) {
  return new Promise(async (resolve, reject) => {
    try {
      const res: any = await apis.notice.getAttachment(
        COMPANY_ID,
        SHOP_ID,
        POST_ID,
        FILE_ID,
        INTERNAL_URL
      );
      if (res == null || res.data == null) {
        resolve([]);
        return;
      }

      resolve(res.data);
    } catch (e) {
      console.log("getNoticeGroupDetail error : ", e);
      reject(e);
    }
  });
}
